export default "custom-vars";
